import type { Currency } from "@tellescope/types-models";

export const getCurrencySymbol = (currency: Currency): string => {
  switch (currency) {
    case "USD":
      return "$";
    default:
      return "$";
  }
};
